import { inject } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';

import { GqlService } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';

export const injectGetPrepaidSummaryQuery = () => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);

  return injectQuery(() => ({
    queryFn: () =>
      gqlToPromise(() => {
        return gqlService.getPrepaidsSummary$();
      }),
    queryKey: ['trials', 'detail', mainQuery.trialKey(), 'get-prepaid-summary'],
  }));
};
